import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";

import Link from "@/components/Link";
import TimeAgo from "@/components/TimeAgo";
import { Indexer as IndexerType } from "@/components/proptypes";

import Form from "antd/lib/form";
import Button from "antd/lib/button";
import Tooltip from "@/components/Tooltip";
import AntAlert from "antd/lib/alert";
import * as Grid from "antd/lib/grid";

import Title from "./Title";
import Query from "./Query";
import IndexerDestinations from "./IndexerDestinations";
import HorizontalFormItem from "../HorizontalFormItem";
import { STATE_CLASS } from "../../pages/indexers/IndexersList";
import DynamicComponent from "@/components/DynamicComponent";
import IndexerInsertStrategy from "./IndexerInsertStrategy";
import IndexerTargetTable from "./IndexerTargetTable";

import "./IndexerView.less";



export default class IndexerView extends React.Component {
  state = {
    refreshing: false,
  };

  refreshData = () => {
    this.setState({ refreshing: true });
    
    // API call to manually trigger the indexer
    fetch(`/api/indexers/${this.props.indexer.id}/refresh`, {
      method: "POST",
    })
      .then(response => {
        if (response.ok) {
          return response.json();
        }
        throw new Error("Failed to refresh data");
      })
      .then(() => {
        this.setState({ refreshing: false });
      })
      .catch(() => {
        this.setState({ refreshing: false });
      });
  };

  render() {
    const { 
      indexer, 
      queryResult, 
      canEdit, 
      onEdit, 
      menuButton, 
      favorite, 
      unfavorite, 
      archive, 
      unarchive 
    } = this.props;
    
    const { query, name, options, state } = indexer;

    return (
      <>
        <Title
          indexer={indexer}
          editMode={false}
          canEdit={canEdit}
          onChange={null}
          name={name}
          tagsExtra={null}
          setIndexerTags={index => unfavorite(index)}
          favorite={favorite}
          unfavorite={unfavorite}
          archive={archive}
          unarchive={unarchive}
        >
          {canEdit && (
            <Button type="primary" onClick={onEdit}>
              <i className="fa fa-edit m-r-5" aria-hidden="true" />
              Edit
            </Button>
          )}
          {menuButton}
        </Title>
        <div className="bg-white tiled p-20">
          <Grid.Row gutter={16}>
            <Grid.Col xs={24} md={16}>
              <HorizontalFormItem labelWidth={2} label="Query">
                <Query query={query} queryResult={queryResult} editMode={false} />
              </HorizontalFormItem>
              <HorizontalFormItem labelWidth={2} label="Destination">
                <IndexerDestinations 
                  indexerId={indexer.id} 
                  viewMode={false} 
                  disabled={true}
                  dataSourceId={options && options.data_source_id ? options.data_source_id : null}
                />
              </HorizontalFormItem>
              <HorizontalFormItem labelWidth={2} label="Target Table">
                <IndexerTargetTable 
                  targetTable={options && options.target_table}
                  viewMode={true}
                />
              </HorizontalFormItem>
              
              <HorizontalFormItem labelWidth={2} label="Insert Strategy">
                <IndexerInsertStrategy 
                  insertStrategy={options && options.insert_strategy}
                  viewMode={true}
                />
              </HorizontalFormItem>
              
              <HorizontalFormItem labelWidth={2} label="Remove Duplicates">
                <div>{options && options.delete_duplicates ? "Yes" : "No"}</div>
              </HorizontalFormItem>
              
              {state === "ok" && (
                <HorizontalFormItem>
                  <Button 
                    type="primary" 
                    onClick={this.refreshData} 
                    loading={this.state.refreshing}
                  >
                    <i className="fa fa-refresh m-r-5" aria-hidden="true" />
                    Refresh Data Now
                  </Button>
                </HorizontalFormItem>
              )}
            </Grid.Col>
          </Grid.Row>
        </div>
      </>
    );
  }
}

IndexerView.propTypes = {
  indexer: IndexerType.isRequired,
  queryResult: PropTypes.object,
  canEdit: PropTypes.bool.isRequired,
  onEdit: PropTypes.func.isRequired,
  menuButton: PropTypes.node.isRequired,
  favorite: PropTypes.func.isRequired,
  unfavorite: PropTypes.func.isRequired,
  archive: PropTypes.func.isRequired,
  unarchive: PropTypes.func.isRequired,
};

IndexerView.defaultProps = {
  queryResult: null,
};
